import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import "../../styles/header.css";

const SiteHeader = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const closeMenu = () => setMenuOpen(false);

  return (
    <header className="site-header">
      <div className="site-header__inner">
        <Link to="/" className="site-header__brand" onClick={closeMenu}>
          Scrap Heap Archive
        </Link>

        <button
          className="site-header__toggle"
          type="button"
          aria-expanded={menuOpen}
          aria-controls="site-header-navigation"
          aria-label={menuOpen ? "Close navigation menu" : "Open navigation menu"}
          onClick={() => setMenuOpen((open) => !open)}
        >
          <span />
          <span />
          <span />
        </button>

        <nav
          className={`site-header__nav${menuOpen ? " site-header__nav--open" : ""}`}
          id="site-header-navigation"
          aria-label="Main navigation"
        >
          <NavLink to="/" end onClick={closeMenu}>Home</NavLink>
          <NavLink to="/map" onClick={closeMenu}>Map</NavLink>
          <NavLink to="/categories" onClick={closeMenu}>Categories</NavLink>
          <NavLink to="/intersection/cybernetics-literature" onClick={closeMenu}>
            Intersections
          </NavLink>
        </nav>
      </div>
    </header>
  );
};

export default SiteHeader;